module.exports = __webpack_public_path__ + "static/media/RadioCanut.ff303375.jpg";